import type { Artwork } from "@artlove365/shared";
import { img, imgSrcSet } from "@artlove365/shared";
import { Link } from "@/lib/router";
import { FavoriteButton } from "@/components/FavoriteButton";
import { useI18n } from "@/lib/i18n";

// Plain markup (no per-card animation): grids render many cards and each animated one costs main-thread time.
export function ArtworkCard({ art, index = 0 }: { art: Artwork; index?: number }) {
  const { tx, href } = useI18n();
  return (
    <div>
      <Link href={href(`/artworks/${art.slug}`)} className="group relative block">
        <FavoriteButton slug={art.slug} size="sm" className="absolute right-3 top-3 z-10 opacity-90 md:opacity-0 md:group-hover:opacity-100 aria-pressed:opacity-100" />
        <div className="overflow-hidden rounded-lg border-[6px] border-surface bg-line shadow-[0_8px_24px_-12px_rgba(0,0,0,.35)]">
          <img
            src={img(art.imageUrl, 500)}
            srcSet={imgSrcSet(art.imageUrl, [330, 500, 800])}
            sizes="(min-width: 1024px) 25vw, (min-width: 768px) 33vw, 50vw"
            width={500} height={625} decoding="async"
            alt={tx(art.title)}
            loading="lazy"
            className="aspect-[4/5] w-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <h3 className="mt-3 font-serif text-xl font-semibold leading-tight">{tx(art.title)}</h3>
        <p className="text-sm text-muted">{art.artistName} · {art.year}</p>
      </Link>
    </div>
  );
}
